import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Snackbar } from '@material-ui/core';
import MuiAlert from '@material-ui/lab/Alert';
import { NotificationTypes } from '../../models/NotificationModel';
import { actions } from '../../actions/notificationActions';
import ErrorNotification from './ErrorNotification';
import SuccessNotification from './SuccessNotification';
import _ from 'lodash';

function renderMessage(notification, index) {
  if (notification.type === NotificationTypes.error) return <ErrorNotification key={index} message={notification.message} />;
  if (notification.type === NotificationTypes.success) return <SuccessNotification key={index} message={notification.message} />;
  return null;
}

const NotificationsHandler = ({ actions, notifications }) => (
  <React.Fragment>
    {notifications.some(n => n.type === NotificationTypes.error) && <Snackbar
      open={notifications.length > 0}
      autoHideDuration={8000}
      onClose={actions.clear}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <MuiAlert elevation={3} severity="error">{_.takeRight(notifications.filter(n => n.type === NotificationTypes.error), 3).map((e, index) => renderMessage(e, index))}</MuiAlert>
    </Snackbar>}
    {notifications.some(n => n.type === NotificationTypes.success) && <Snackbar
      open={notifications.length > 0}
      autoHideDuration={8000}
      onClose={actions.clear}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      <MuiAlert elevation={3} severity="success">{_.takeRight(notifications.filter(n => n.type === NotificationTypes.success), 3).map((e, index) => renderMessage(e, index))}</MuiAlert>
    </Snackbar>}
  </React.Fragment>
);

NotificationsHandler.propTypes = {
  notifications: PropTypes.array,
  actions: PropTypes.object.isRequired,
};

function mapDispatchToProps(dispatch) {
  return {
    actions: bindActionCreators(actions, dispatch),
  };
}

function mapStateToProps(state) {
  return {
    notifications: state.notifications,
  };
}

export default connect(mapStateToProps, mapDispatchToProps)(NotificationsHandler);



// WEBPACK FOOTER //
// ./src/components/notifications/NotificationsHandler.js